import { use, useState, useEffect } from 'react'
import { Flex } from '@radix-ui/themes'
import { Card } from '@/api-client/data-contracts'
import { styles } from './styles.css'
import brands from './brands.png'

type Props = {
  creditCard: Promise<Card | null>
  onInitialized: (card: Card | null) => void
  onUpdate: (values: { holderName: string, numberElement: any }) => void
}

export const CreditCardForm: React.FC<Props> = ({ creditCard, onInitialized, onUpdate }) => {
  const card = use(creditCard)
  const [numberElement, setNumberElement] = useState(null)
  const [holderName, setHolderName] = useState('')

  useEffect(() => {
    if (!window.payjpInstance) return
    if (card) {
      onInitialized(card)
      return
    }

    const elements = window.payjpInstance.elements()
    const style = {
      base: {
        fontFamily: '-apple-system, "BlinkMacSystemFont", "Hiragino Kaku Gothic ProN", Sans-Serif',
        color: '#252525',
        caretColor: '#252525',
        backgroundColor: 'white',
        fontSize: '14px',
        fontWeight: '700',
        lineHeight: '44px',
        letterSpacing: 'normal',
        '::placeholder': {
          display: 'none',
        },
      },
    }
    const number = elements.create('cardNumber', { style, placeholder: '' })
    const expiry = elements.create('cardExpiry', { style })
    const cvc = elements.create('cardCvc', { style, placeholder: '' })

    number.mount('#card-number')
    expiry.mount('#card-expiry')
    cvc.mount('#card-cvc')

    setNumberElement(number)

    onInitialized(null)
  }, [])

  useEffect(() => onUpdate({ holderName, numberElement }), [holderName, numberElement])

  return card ? (
    <>
      <p className={styles.heading}>クレジットカード</p>
      <span className={styles.maskedNumber}>**** **** **** {card.attributes.last4}</span>
    </>
  ) : (
    <Flex direction="column" align="start" gap="16px" width="100%">
      <img src={brands} className={styles.brands} />
      <Flex direction="column" align="start" gap="4px" width="100%">
        <label htmlFor="card-number" className={styles.label}>
          クレジットカード番号
        </label>
        <div className={styles.payjpInputContainer} id="card-number"></div>
      </Flex>
      <Flex direction="column" align="start" gap="4px" width="100%">
        <label htmlFor="card-holder-name" className={styles.label}>
          カード名義
        </label>
        <div className={styles.payjpInputContainer} id="card-holder-name">
          <input type="text" className={styles.payjpInput} onChange={(e) => setHolderName(e.target.value)} />
        </div>
      </Flex>
      <Flex direction="row" gap="16px" width="100%">
        <Flex direction="column" align="start" gap="4px" width="100%">
          <label htmlFor="card-expiry" className={styles.label}>
            有効期限
          </label>
          <div className={styles.payjpInputContainer} id="card-expiry"></div>
        </Flex>
        <Flex direction="column" align="start" gap="4px" width="100%">
          <label htmlFor="card-cvc" className={styles.label}>
            セキュリティコード
          </label>
          <div className={styles.payjpInputContainer} id="card-cvc"></div>
        </Flex>
      </Flex>
    </Flex>
  )
}
